@if (this.displayIdleService.isLocked()) {
    <div
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-md">
        @if (!showMethod()) {
            <div
                class="w-11/12 rounded-xl bg-white p-6 text-center shadow-xl md:w-1/3">
                @if (pinMatchedMessage()) {
                    <p class="mb-3 bg-red-50 px-2 py-1 text-xs text-red-400">
                        {{ pinMatchedMessage() }}
                    </p>
                }
                <h2 class="mb-4 text-xl font-bold">Enter PIN</h2>
                <input
                    type="password"
                    [(ngModel)]="pin"
                    maxlength="6"
                    class="w-full rounded border p-2 text-center text-lg tracking-widest" />

                <p-button
                    label="Unlock"
                    size="large"
                    [loading]="loading()"
                    severity="primary"
                    styleClass="w-full mt-4"
                    (onClick)="onVerifyPin()" />

                <p-button
                    styleClass="text-gray-900 font-xs mt-2"
                    label="Forgot PIN Code?"
                    (onClick)="forgotPin()"
                    link />
            </div>
        }
        @if (showMethod()) {
            <div
                class="relative w-11/12 rounded-xl bg-white px-6 py-10 text-center shadow-xl md:w-1/3">
                <p>Please select preferred method!</p>
                <div class="mt-3 flex flex-wrap gap-4">
                    <div class="flex items-center">
                        <p-radiobutton
                            name="pizza"
                            value="email"
                            [(ngModel)]="method" />
                        <label for="" class="ml-2">Email</label>
                    </div>

                    <div class="flex items-center">
                        <p-radiobutton
                            name="pizza"
                            value="phone"
                            [(ngModel)]="method" />
                        <label for="" class="ml-2">Phone</label>
                    </div>
                </div>

                <div class="">
                    <p-button
                        label="Send {{
                            method() === 'email' ? 'Email' : 'SMS'
                        }}"
                        size="large"
                        [loading]="loading()"
                        severity="primary"
                        styleClass="w-full mt-4"
                        (onClick)="sendCode()" />
                </div>

                <p-button
                    styleClass="absolute top-3 right-3"
                    icon="pi pi-times"
                    [rounded]="true"
                    severity="secondary"
                    size="small"
                    [outlined]="true"
                    (onClick)="cancel()" />

                @if (errMessage()) {
                    <p class="mt-3 bg-red-50 px-2 py-1 text-xs text-red-400">
                        {{ errMessage() }}
                    </p>
                }
            </div>
        }
    </div>
}
